import { articleSlice } from "./articleSlice";
import * as defaultActions from "../../../../../redux/_common";

const { actions } = articleSlice;
const moduleUrl = '/api/pricing/pricingConditions/article'

export const setValidationErrors = actions.setValidationErrors;

export const getDropDownItems = (params: {}) => defaultActions.getDropDownItems(`${moduleUrl}/select`, actions, params);
export const clearItem = () => defaultActions.clearItem(actions);
export const clear = () => defaultActions.clearAll(actions);